var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.68 227.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-12,.cls-19,.cls-23,.cls-6,.cls-9{fill-rule:evenodd;}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}.cls-23{fill:url(#linear-gradient-23);}.cls-24{fill:url(#linear-gradient-24);}.cls-25{fill:url(#linear-gradient-25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 196.22,
    y1: 115.65,
    x2: 182.07,
    y2: 106.65,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 228.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 190.8,
    y1: 126.87,
    x2: 179.58,
    y2: 119.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 193.88,
    y1: 144.83,
    x2: 170.92,
    y2: 130.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 73.85,
    y1: 214.28,
    x2: 91.5,
    y2: 135.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 228.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 31.53,
    y1: 193.42,
    x2: 46.77,
    y2: 125.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 31.53,
    y1: 193.42,
    x2: 46.77,
    y2: 125.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 22.17,
    y1: 191.33,
    x2: 37.42,
    y2: 123.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 118.85,
    y1: 212.93,
    x2: 134.1,
    y2: 144.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 68.95,
    y1: 201.78,
    x2: 84.2,
    y2: 133.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 52.04,
    y1: 198.01,
    x2: 67.29,
    y2: 129.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 118.85,
    y1: 212.93,
    x2: 134.1,
    y2: 144.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 118.85,
    y1: 212.93,
    x2: 134.1,
    y2: 144.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 128.42,
    y1: 110.18,
    x2: 103.02,
    y2: 21.12,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 25.28,
    y1: 80.02,
    x2: 118.22,
    y2: 140.61,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 228.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9aa9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 23.09,
    y1: 83.38,
    x2: 116.03,
    y2: 143.97,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 29.15,
    y1: 74.08,
    x2: 122.1,
    y2: 134.67,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 30.9,
    y1: 71.39,
    x2: 123.85,
    y2: 131.98,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 73.62,
    y1: 5.87,
    x2: 166.56,
    y2: 66.45,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 62.02,
    y1: 23.66,
    x2: 154.96,
    y2: 84.25,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 31.25,
    y1: 70.86,
    x2: 124.19,
    y2: 131.45,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 53.2,
    y1: 37.19,
    x2: 146.14,
    y2: 97.78,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 44.64,
    y1: 50.32,
    x2: 137.58,
    y2: 110.91,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 44.64,
    y1: 50.32,
    x2: 137.58,
    y2: 110.91,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 89.25,
    y1: -18.12,
    x2: 182.2,
    y2: 42.47,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 93.66,
    y1: -24.88,
    x2: 186.6,
    y2: 35.71,
    xlinkHref: "#linear-gradient-14"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "misc-qr-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.11,115a1.9,1.9,0,0,1,.84-1.12,2,2,0,0,1,1.38-.22l17.81,3.73a1.88,1.88,0,0,1,1.49,2.26l-.35,1.42a1.87,1.87,0,0,1-2.37,1.29l-17.46-5.13a1.88,1.88,0,0,1-1.12-.85A2,2,0,0,1,178.11,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.86,106.29a1.19,1.19,0,0,1,0-.46,1.35,1.35,0,0,1,.2-.42,1.43,1.43,0,0,1,.35-.3,1.1,1.1,0,0,1,.44-.15l11.7-1.81a1.32,1.32,0,0,1,.95.22,1.25,1.25,0,0,1,.51.83l.14,1a1.15,1.15,0,0,1,0,.49,1,1,0,0,1-.23.43,1.15,1.15,0,0,1-.38.31,1.26,1.26,0,0,1-.47.12l-11.84.86a1.29,1.29,0,0,1-.89-.27A1.27,1.27,0,0,1,177.86,106.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.14,100.57a2.05,2.05,0,0,1,.46-2.86l16.68-15.15a2.29,2.29,0,0,1,3.16-.2l1,1.1a2.09,2.09,0,0,1-.61,3l-17.69,14A2.25,2.25,0,0,1,172.14,100.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.48,99.56,35.7,102l-22-.42L.12,36.72A5.5,5.5,0,0,1,2.38,31a5.74,5.74,0,0,1,2-.86L144.54.12a5.56,5.56,0,0,1,2.15,0,5.44,5.44,0,0,1,2,.79,5.68,5.68,0,0,1,1.55,1.5,5.51,5.51,0,0,1,.84,2l15,71.08-15.7-4.27s-15.37,8.41-17.86,10L99.75,74.09,78,96.67,49.58,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.13,50.84a.8.8,0,0,1,.61-1l17.15-3.84a.82.82,0,0,1,1,.61l3.83,17.15a.82.82,0,0,1-.61,1L29.92,68.6A.82.82,0,0,1,29,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.87,41.15a.8.8,0,0,1,.61-.95l42.1-9.41a.8.8,0,0,1,1,.61l9.41,42.1a.8.8,0,0,1-.61,1l-42.1,9.41a.79.79,0,0,1-.95-.61ZM54.7,69.61a.81.81,0,0,0,.61-1L48.69,39a.81.81,0,0,0-.95-.61L18.11,45a.82.82,0,0,0-.61,1l6.62,29.62a.81.81,0,0,0,.95.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.62,90.1a.79.79,0,0,0-.6,1l1,4.68a.8.8,0,0,0,1,.6l4.68-1a.79.79,0,0,1,.95.6L30,101.83l5.74.29L39,99.81l8.44-8L46,85.48a.82.82,0,0,0-1-.61l-4.67,1a.79.79,0,0,0-.61,1l1.05,4.68a.8.8,0,0,1-.61,1l-4.68,1a.8.8,0,0,1-1-.61l-1-4.68a.79.79,0,0,0-1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154.36,72.32l-1-4.29a.82.82,0,0,0-1-.61l-4.67,1a.81.81,0,0,1-1-.61l-1-4.68a.8.8,0,0,0-1-.6L133.9,65a.8.8,0,0,0-.61,1l1.22,5.46-5.46,1.22a.81.81,0,0,1-1-.61l-1-4.68a.79.79,0,0,0-1-.6L109,70.59a.81.81,0,0,0-.61,1l1,4.51,2.19.51,3.48-.78a.8.8,0,0,1,1,.61l.28,1.26L126,79.89l2.93-.66a.81.81,0,0,1,1,.61l.22,1,2.53.59,8.3-4.87-4.21.94a.79.79,0,0,1-1-.6l-1.22-5.46L140,70.21a.79.79,0,0,1,.95.61l1.13,5.05,8.06-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.32,80.63l-2.47.55-1.22-5.46a.79.79,0,0,1,.61-1l10.91-2.44a.8.8,0,0,0,.61-1L96.53,48a.8.8,0,0,0-1-.61L90.12,48.6l-1.39-6.24,5.45-1.21a.81.81,0,0,0,.61-1l-1.05-4.68a.79.79,0,0,0-.95-.6l-5.46,1.22-1.22-5.46a.8.8,0,0,1,.61-1l4.68-1a.79.79,0,0,0,.6-1L91,23a.82.82,0,0,0-1-.61L79.09,24.87a.81.81,0,0,0-.61,1l2.44,10.91a.81.81,0,0,0,1,.61l5.45-1.22,1.4,6.23-5.46,1.22a.82.82,0,0,0-.61,1l1,4.68a.79.79,0,0,0,1,.6l5.46-1.22,1.22,5.46a.79.79,0,0,1-.61.95l-4.67,1.05a.79.79,0,0,0-.61.95l1.22,5.46-5.46,1.22a.79.79,0,0,0-.6,1l1,4.68a.79.79,0,0,1-.6,1l-4.68,1a.81.81,0,0,1-1-.61l-4-17.93,5.46-1.22a.79.79,0,0,0,.6-1L72.25,27.22a.82.82,0,0,0-1-.61l-4.68,1.05a.79.79,0,0,0-.6.95l1,4.68a.79.79,0,0,1-.6,1l-4.68,1a.8.8,0,0,0-.61,1L63.6,47.16a.8.8,0,0,0,1,.6l4.67-1a.8.8,0,0,1,1,.6l1.22,5.46L66,54a.81.81,0,0,0-.61,1l5.4,24.17L59.05,81.74a.8.8,0,0,0-.61,1l1.05,4.68a.79.79,0,0,0,.95.6l10.92-2.43a.8.8,0,0,0,.6-1l-1.22-5.46,5.46-1.21a.79.79,0,0,1,1,.6l2.44,10.92a.79.79,0,0,1-.6.95l-4.68,1a.82.82,0,0,0-.61,1L74.51,96l3.37.82L86,88.33a.83.83,0,0,1-.14-.3l-1-4.68a.79.79,0,0,1,.6-.95l5.46-1.22.37,1.65ZM86.67,62.47l1.22,5.46a.79.79,0,0,0,1,.6l4.68-1a.82.82,0,0,0,.61-1l-1-4.67a.8.8,0,0,0-1-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M67.58,94.29l-2.92-.71,1.85-.41a.8.8,0,0,1,1,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M112.46,31.33a.79.79,0,0,1,.6-.95l17.16-3.83a.79.79,0,0,1,.95.6L135,44.31a.79.79,0,0,1-.6.95l-17.16,3.83a.79.79,0,0,1-.95-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.2,21.65a.8.8,0,0,1,.6-1l42.1-9.4a.8.8,0,0,1,1,.6l9.4,42.1a.8.8,0,0,1-.6,1l-42.11,9.4a.79.79,0,0,1-1-.6ZM142,50.1a.79.79,0,0,0,.6-1L136,19.52a.79.79,0,0,0-.95-.6l-29.63,6.62a.79.79,0,0,0-.6.95l6.61,29.63a.8.8,0,0,0,1,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M171.84,227.42,34.06,187.85A5.53,5.53,0,0,1,30.28,181l21.61-75,17.85,12.06L88.88,113h0l21.16,19.78,31.78-10.19,24.43,21.76,22.66-.55,9.31,12-19.55,67.84a5.53,5.53,0,0,1-6.84,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M69.48,117.76l5.33-1.16,10.71-2.42L84.43,118l-5.38-1.53a.8.8,0,0,0-1,.55l-1.53,5.38-12.3-3.51,1.08-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M62.48,125.05l-5.38-1.53a.81.81,0,0,1-.55-1l1.32-4.61a.8.8,0,0,1,1-.55l5.37,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M74.77,128.55l-1.53,5.38a.8.8,0,0,1-1,.55L61.5,131.41a.79.79,0,0,1-.55-1l1.53-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M80.92,130.31l-6.15-1.76,1.76-6.14,6.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M139.77,180.31l-6.15-1.75-1.53,5.38a.79.79,0,0,0,.55,1l5.38,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M88.82,125.91l-1.53,5.38a.81.81,0,0,1-1,.55l-5.38-1.53-1.53,5.37a.8.8,0,0,0,.55,1l16.9,4.82a.81.81,0,0,0,1-.55l1.53-5.38,11.52,3.29a.8.8,0,0,0,1-.55l1.32-4.61a.79.79,0,0,1,1-.55l10.76,3.07a.81.81,0,0,0,1-.55l1.53-5.38L133.6,132l-3.29,11.52a.8.8,0,0,1-1,.55L118.57,141a.8.8,0,0,0-1,.55L116.05,147l-11.53-3.28a.8.8,0,0,0-1,.55L100.47,155a.8.8,0,0,0,.55,1l5.38,1.53-3.51,12.3-5.38-1.54a.8.8,0,0,0-1,.55l-1.32,4.61a.8.8,0,0,0,.55,1l5.38,1.53-1.53,5.38a.8.8,0,0,1-1,.55L94,180.56a.8.8,0,0,0-1,.55L90,191.86a.79.79,0,0,0,.54,1l4.61,1.31a.8.8,0,0,0,1-.55L97.42,189a.78.78,0,0,1,1-.54l11.53,3.28-1.54,5.38a.81.81,0,0,0,.55,1l41.49,11.82a.8.8,0,0,0,1-.55l1.31-4.61a.79.79,0,0,0-.55-1l-10.75-3.07a.8.8,0,0,1-.55-1l1.31-4.61a.8.8,0,0,1,1-.55l10.75,3.07a.8.8,0,0,0,1-.55l1.32-4.61a.81.81,0,0,0-.55-1l-4.61-1.31a.8.8,0,0,1-.55-1l1.53-5.38,5.38,1.54a.81.81,0,0,0,1-.55l1.31-4.61a.8.8,0,0,0-.55-1l-5.38-1.53,1.54-5.38a.8.8,0,0,1,1-.55l16.91,4.82a.8.8,0,0,0,1-.55l1.54-5.38,5.37,1.54a.8.8,0,0,0,1-.55l3.07-10.76a.81.81,0,0,0-.55-1L180,158.56a.8.8,0,0,1-.55-1l1.53-5.38,5.38,1.54a.8.8,0,0,0,1-.55l2.38-8.36-.84-1.16s-6.27.21-12.25.45l0,.19-.56-.16c-4.35.17-8.42.35-9.65.46l-2.52-2.29-1.1,3.86a.8.8,0,0,1-1,.55l-5.38-1.53,1.53-5.38a.8.8,0,0,1,1-.55l2.29.65-7.91-7.17-1.08,3.78a.8.8,0,0,1-1,.55l-17.67-5,1.53-5.38a.81.81,0,0,0-.55-1l-1.25-.35-4.93,1.62-1,3.35-4.93-1.41L110.1,133l-2.65-2.48a.8.8,0,0,1-1,.47l-5.38-1.53,1.09-3.83L98.34,122l-.85-.24a.8.8,0,0,0-1,.55L95,127.66ZM95,127.66l6.14,1.76-1.75,6.14L94,134a.8.8,0,0,1-.55-1Zm79.9,22.78L171.58,162a.8.8,0,0,0,.55,1l4.61,1.32a.8.8,0,0,1,.55,1l-1.53,5.38-36.88-10.51,3.5-12.29,5.38,1.53a.8.8,0,0,0,1-.55l1.31-4.61a.81.81,0,0,1,1-.55l5.38,1.54-3.29,11.52a.81.81,0,0,0,.55,1L158.3,159a.8.8,0,0,0,1-.55l1.31-4.61a.81.81,0,0,1,1-.55l4.61,1.32a.81.81,0,0,0,1-.55l1.31-4.61a.8.8,0,0,1,1-.55Zm-32.49-2.61L137,146.29a.79.79,0,0,1-.55-1l1.31-4.61a.8.8,0,0,1,1-.55l4.61,1.31a.8.8,0,0,1,.55,1Zm-2.61,32.48,3.28-11.52a.79.79,0,0,0-.55-1l-4.6-1.32a.79.79,0,0,1-.55-1l1.53-5.38-5.38-1.53a.8.8,0,0,0-1,.55l-1.31,4.61a.79.79,0,0,1-1,.54l-5.38-1.53,3.29-11.52a.8.8,0,0,0-.55-1L116.05,147l-1.54,5.38a.79.79,0,0,1-1,.55l-4.61-1.31a.8.8,0,0,0-1,.55l-1.53,5.37,5.37,1.54a.8.8,0,0,1,.55,1l-3.06,10.75a.8.8,0,0,1-1,.55l-5.38-1.53-1.75,6.14,5.38,1.54a.8.8,0,0,1,.55,1l-1.32,4.61a.8.8,0,0,0,.55,1l5.38,1.53-1.75,6.15,5.38,1.53a.79.79,0,0,0,1-.55l1.32-4.61a.8.8,0,0,0-.55-1l-5.38-1.54,1.53-5.37a.8.8,0,0,1,1-.55l4.61,1.31a.8.8,0,0,0,1-.55l1.31-4.61a.8.8,0,0,0-.55-1L116,173.52a.8.8,0,0,1-.55-1l3.07-10.75a.8.8,0,0,1,1-.55l5.37,1.53-1.53,5.38a.81.81,0,0,0,.55,1l10.76,3.06a.81.81,0,0,1,.55,1l-1.54,5.38L128.24,177a.78.78,0,0,0-1,.54l-3.07,10.76a.81.81,0,0,0,.55,1l4.61,1.31a.8.8,0,0,1,.55,1l-1.31,4.61a.8.8,0,0,0,.54,1l4.61,1.31a.8.8,0,0,0,1-.55L138,186.46l5.37,1.53a.8.8,0,0,0,1-.55l1.54-5.38,6.14,1.75,1.75-6.14-5.37-1.53a.79.79,0,0,0-1,.54l-1.53,5.38Zm35.1-29.87,1.75-6.14,5.38,1.53a.8.8,0,0,1,.55,1L181,152.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M88.82,125.91l1.53-5.38a.79.79,0,0,0-.55-1L84.43,118l-1.76,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M148.05,128l-.19.66a.8.8,0,0,0,.55,1l2.12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M61.4,152.15a.8.8,0,0,1,1-.55l16.9,4.82a.81.81,0,0,1,.55,1L75,174.31a.8.8,0,0,1-1,.55L57.13,170a.8.8,0,0,1-.55-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53.6,135.81a.8.8,0,0,0-1,.55L40.79,177.84a.79.79,0,0,0,.54,1l41.49,11.83a.8.8,0,0,0,1-.55l11.83-41.49a.8.8,0,0,0-.55-1Zm25.81,46.4a.79.79,0,0,1-1,.55l-29.2-8.32a.81.81,0,0,1-.55-1L57,144.26a.79.79,0,0,1,1-.55L87.19,152a.8.8,0,0,1,.55,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M164.13,188.09a.8.8,0,0,1,1-.55l10.76,3.06a.81.81,0,0,1,.55,1l-3.07,10.76a.8.8,0,0,1-1,.55l-4.61-1.32a.8.8,0,0,1-.55-1l1.32-4.61a.8.8,0,0,0-.55-1l-4.61-1.32a.8.8,0,0,1-.55-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M164.48,207.29a.79.79,0,0,1,.54,1l-1.31,4.61a.8.8,0,0,1-1,.55l-4.61-1.32a.8.8,0,0,1-.55-1l1.32-4.61a.8.8,0,0,1,1-.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.2ff89fb622b23e813c473d2ecf233020.svg";
export { ForwardRef as ReactComponent };